<script>

    import VcPaginacao from '@/components/Form/Paginacao'

    export default {
        components: {
            VcPaginacao
        },
        data() {
            return {
                data: {},
                termo: '',
                pagination: {},
                filtro: null,
                order: 'ASC',
                campo: 'nome',
                porPagina: {label: '100', value: '100'},
                cultura: { label: "Todos", value: "TODAS" }
            }
        },

        watch: {
            termo() {
                this.navigate(1);
            },
            porPagina() {
                this.navigate(1);
            },
            cultura() {
                this.navigate(1);
            },
            filtro() {
                this.navigate(1);
            }
        },
        methods: {
            navigate(pagina) {
                this.$http.post('api/culturas/listagem?page=' + pagina, {
                    termo: this.termo,
                    campo: this.campo,
                    ordem: this.order,
                    porPg: this.porPagina.value,
                    cultura: this.cultura.value
                }).then((response) => {
                    this.data = response.data.data;
                    this.pagination = response.data;
                });
            },
            ordenar(campo) {
                this.$set(this, 'campo', campo);
                if (this.order === 'ASC') {
                    this.order = 'DESC';
                } else {
                    this.order = 'ASC';
                }
                this.navigate(1);
            },
            alterar(model) {
                this.$router.push({name: 'culturas.editar', params: {id: model.id}});
            },
            remover(model) {
                window.swal({
                    title: "Deseja realmente remover?",
                    text: "A operação não poderá ser revertida",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#02d600',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('api/culturas/' + model.id).then((response) => {
                            if (response.data.erro == 1) {
                                return window.swal({'title': 'Atenção!', 'text': "Não foi possível remover a cultura selecionada. " + response.data.mensagem, 'type': 'warning'});
                            }
                            window.swal({'title': 'Sucesso!', 'text': "Cultura removida com sucesso!", 'type': 'success'})
                        }).then(() => {
                            this.navigate(this.pagination.current_page)
                        })
                    }
                })

            }
        },
        mounted() {
            this.navigate(1)
            this.$store.dispatch('setTitle', 'Culturas')
        }
    }

</script>

<template>
    <div class="margin-top-10">

        <router-link :to="{name: 'culturas.adicionar'}" class="btn btn-success">Adicionar</router-link>

        <br/>
        <br/>

        <div class="panel">
            <div class="panel-body">
                <div class="row">
                    <div class="col-sm-4">
                        <label>Registros por página </label>
                        <v-select v-model="porPagina" :options="[
                            {label: '10', value: '10'},
                            {label: '25', value: '25'},
                            {label: '50', value: '50'},
                            {label: '100', value: '100'},
                        ]"></v-select>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                        <label>Tipo </label>
                        <v-select v-model="cultura" :options="[
                            {label: 'Todos', value: 'TODAS'},
                            {label: 'Solos', value: 'SOLO'},
                            {label: 'Tecidos', value: 'TECIDO'}
                        ]"></v-select>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>&nbsp;</label>
                            <input type="text" v-model="termo" class="form-control" placeholder="Pesquisar">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-hover dataTable table-striped">
                            <thead>
                            <tr role="row">
                                <th @click="ordenar('nome')" width="60%"> Nome</th>
                                <th @click="ordenar('tipo')" width="25%"> Tipo</th>
                                <th class="text-center" width="15%">Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr role="row" class="even" v-for="model in data">
                                <td>{{ model.nome }}</td>
                                <td>{{ model.tipo }}</td>
                                <td class="text-center">
                                    <button class="btn btn-xs btn-success" @click="alterar(model)">
                                        <i class="fa fa-pen"></i>
                                    </button>
                                    &nbsp;
                                    <button class="btn btn-xs btn-danger" @click="remover(model)">
                                        <i class="fa fa-times"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <vc-paginacao :source="pagination" @navigate="navigate"></vc-paginacao>
            </div>
        </div>
    </div>

</template>

<style scoped>

    table th {
        font-size: 15px !important;
    }

    table td {
        font-size: 13px !important;
    }

    table.dataTable thead th, table.dataTable thead td {
        padding: 10px 18px;
        border-bottom: 1px solid #111
    }

    @media screen and (max-width: 584px) {
        table th:nth-child(2) {
            display: none;
        }

        table td:nth-child(2) {
            display: none;
        }
    }

    @media screen and (max-width: 445px) {
        table th:nth-child(3) {
            display: none;
        }

        table td:nth-child(3) {
            display: none;
        }
    }

</style>
